import { motion } from "framer-motion";

const clips = [
  {
    n: "V.01",
    title: "TURNTABLE / CLOSE QUARTERS",
    src: "https://videos.pexels.com/video-files/4043977/4043977-hd_1920_1080_24fps.mp4",
    poster: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1200&q=80",
  },
  {
    n: "V.02",
    title: "NIGHTCLUB ROTATION",
    src: "https://videos.pexels.com/video-files/4043980/4043980-hd_1920_1080_24fps.mp4",
    poster: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=1200&q=80",
  },
  {
    n: "V.03",
    title: "DECK INSPECTION",
    src: "https://videos.pexels.com/video-files/2022395/2022395-hd_1920_1080_30fps.mp4",
    poster: "https://images.pexels.com/photos/7173400/pexels-photo-7173400.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    n: "V.04",
    title: "SIGNAL PATH",
    src: "https://videos.pexels.com/video-files/1580455/1580455-hd_1920_1080_30fps.mp4",
    poster: "https://images.pexels.com/photos/5949085/pexels-photo-5949085.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
];

export default function Videos() {
  return (
    <section id="videos" data-testid="videos-section" className="border-b border-white/15">
      <div className="px-4 sm:px-8 py-20 sm:py-28">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <div>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              className="font-mono-x text-[11px] tracking-[0.3em] text-white/40 uppercase mb-4"
              data-testid="videos-overline"
            >
              [02] — GEAR / FOOTAGE
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="font-mono-x font-extrabold uppercase tracking-tighter leading-[0.9] text-4xl sm:text-6xl"
              data-testid="videos-title"
            >
              MACHINES
              <br />
              <span className="text-stroke">IN MOTION</span>
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="max-w-xs font-mono-x text-[11px] leading-relaxed tracking-wider text-white/50 uppercase"
            data-testid="videos-description"
          >
            Field recordings from the booth. Decks, mixers and the hands that abuse them.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 border-t border-l border-white/15">
          {clips.map((c, i) => (
            <motion.figure
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group border-r border-b border-white/15"
              data-testid={`video-${c.n.toLowerCase().replace(".", "-")}`}
            >
              <div className="relative aspect-video overflow-hidden bg-black">
                <video
                  src={c.src}
                  poster={c.poster}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-500"
                />
                <div className="absolute inset-0 scanline pointer-events-none" />
              </div>
              <figcaption className="flex items-center justify-between px-5 py-4 border-t border-white/15 group-hover:bg-white transition-colors duration-200">
                <span className="font-mono-x text-[10px] tracking-[0.25em] text-[#ff3b1d]">
                  {c.n}
                </span>
                <span className="font-mono-x text-xs sm:text-sm font-bold uppercase tracking-tight group-hover:text-black transition-colors duration-200">
                  {c.title}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
